/* Storefront controls only. Shopify checkout requires an admin-level restriction. */
(() => {
  const purchasePath = /\/(?:cart(?:\/(?:add|change|update|clear))?(?:\.js)?|checkout|checkouts)(?:\/|$)/;
  function isPurchaseUrl(value) {
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && purchasePath.test(url.pathname);
    } catch { return false; }
  }
  document.addEventListener('submit', (event) => {
    if (isPurchaseUrl(event.target.action)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', (event) => {
    const control = event.target.closest('a, button, input[type="submit"]');
    if (!control) return;
    if ((control.tagName === 'A' && isPurchaseUrl(control.href)) ||
        control.name === 'add' || control.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
